import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  private loadTransaction = new BehaviorSubject<any>(null);

  constructor(private apiService: ApiService) { }

  loadTokens() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.FETCH_TOKENS);
  }

  loadTransactions(params: any) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.ACCOUNT_TRANSACTIONS + params);
  }

  addTokens(param: any) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TOKENS, param);
  }

  giftTokens(param: any) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TOKENS + API_ENDPOINTS.API.GIFT_TOKENS, param);
  }

  transferTokens(param: any) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TOKENS + API_ENDPOINTS.API.TRANSFER_TOKENS, param);
  }

  getOTP(param?: any) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.OTP, param);
  }

  verifyOTP(param) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.VERIFY_OTP, param);
  }

  fetchGiftedTokens() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TOKENS + API_ENDPOINTS.API.FETCH_GIFTED_TOKENS);
  }

  approveRejectGiftedTokens(param: any) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TOKENS + API_ENDPOINTS.API.APPROVE_REJECT_GIFTED_TOKENS, param);
  }

  setTransaction(data) {
    this.loadTransaction.next(data);
  }

  refreshTransaction(): Observable<any> {
    return this.loadTransaction.asObservable();
  }

  recentTransactionDetails() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.TOKENS}${API_ENDPOINTS.API.RECENT_PAYMENT_STATUS}`
    return this.apiService.get(url)
  }

  cancelPayment(obj) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.TOKENS}${API_ENDPOINTS.API.CANCEL_PAYMENT}`
    return this.apiService.delete(url, obj);
  }

  withdrawTokens(params) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.WITHDRAW_REQUEST, params);
  }

  getSavedAccount(){
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SAVED_ACCOUNTS);
  }

  deleteSavedAccount(id){
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SAVED_ACCOUNTS + '/' + id);
  }

  editSavedAccount(id, params){
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SAVED_ACCOUNTS + '/' + id, params);
  }
}
